import { render, staticRenderFns } from "./Fornitura.vue?vue&type=template&id=40a4617a&"
import script from "./Fornitura.vue?vue&type=script&lang=js&"
export * from "./Fornitura.vue?vue&type=script&lang=js&"
import style0 from "./Fornitura.vue?vue&type=style&index=0&id=40a4617a&prod&css=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports